import { useState } from "react";
import axios from "axios";
import { ToastBottomEnd } from "views/components/Toast";
import {
  toastEditSuccessMessageConfig,
  toastErrorMessageWithParameterConfig,
} from "config/toastConfig";
import { verifyTokenExpire } from "middleware/verifyToken";

export const useIaDataForm = (config) => {
  const [formData, setFormData] = useState({
    query: config?.query || [],
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateQuery = (newQuery) => {
    setFormData((prev) => ({ ...prev, query: newQuery }));
    if (errors.query) {
      setErrors((prev) => ({ ...prev, query: [] }));
    }
  };

  const submitForm = async () => {
    if (!verifyTokenExpire()) return;

    setIsSubmitting(true);
    try {
      await axios.post(
        `http://212.83.146.159:5550/api/v1/dash/update-query`,
        {
          query: formData.query?.join?.(",") || "",
        },
        {
          headers: {
            Authorization: `Bearer ${config?.api_key}`,
            "App-name": config?.name || "",
          },
        }
      );

      setErrors({});
      ToastBottomEnd.fire(toastEditSuccessMessageConfig());
    } catch (error) {
      const errorData = error.response?.data?.error || {};
      setErrors(errorData);

      if (error.response?.data?.code === 422) {
        ToastBottomEnd.fire(
          toastErrorMessageWithParameterConfig(
            "Veuillez remplir le(s) champ(s) obligatoire(s)"
          )
        );
      } else {
        ToastBottomEnd.fire(toastErrorMessageWithParameterConfig());
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    formData,
    errors,
    isSubmitting,
    updateQuery,
    submitForm,
  };
};
